import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    imports: [
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./imprint.component.scss']
})
export class ImprintComponent {

}
